import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AIInterviewerBase } from '@player/shared/directives/ai-interviewer-base';
import { AsyncPipe } from '@angular/common';
import { BasicModule } from '@shared/modules/basic.module';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'ai-interviewer',
  templateUrl: './ai-interviewer.component.html',
  styleUrls: ['./ai-interviewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, BasicModule, MatIcon],
})
export class AIInterviewer extends AIInterviewerBase {}
